import { useTranslation } from "react-i18next";
import * as Yup from "yup";

export const YupOne = () => {
  const { t } = useTranslation();
  return {
    client_visit_date: Yup.string()
      .required(
        t("validation.required", {
          client_visit_date: t("page.client_visit_date"),
        })
    ),
    clinic_name: Yup.string()
      .required(
        t("validation.required", {
          clinic_name: t("page.clinic_name"),
        })
    ),
    clinic_id: Yup.string()
      .required(
        t("validation.required", {
          clinic_id: t("page.clinic_id"),
        })
    ),
    client_name: Yup.string()
      .required(
        t("validation.required", {
          client_name: t("page.client_name"),
        })
    ),
    client_phoneNumber: Yup.number()
      .required(
        t("validation.required", {
          client_phoneNumber: t("page.client_phoneNumber"),
        })
    ),
    client_age: Yup.number()
      .required(
        t("validation.required", {
          client_age: t("page.client_age"),
        })
    ),
    client_region_id: Yup.string()
      .required(
        t("validation.required", {
          client_region_id: t("page.client_region_id"),
        })
    ),
    client_township_id: Yup.string()
    .required(
      t("validation.required", {
        client_township_id: t("page.client_township_id"),
      })
    ),
    client_gender: Yup.string()
    .required(
      t("validation.required", {
        client_gender: t("page.client_gender"),
      })
    )    
  };
};
 